import { useMemo } from 'react';
import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { ProjectsDocument } from 'graphql/generated/graphql';

const useProjects = () => {
  const { data, loading } = useQuery(ProjectsDocument);

  const projects = useMemo(() => get(data, 'projects', []), [data]);

  return [projects, loading] satisfies [typeof projects, boolean];
};

export default useProjects;
